import React from "react";
import { FormGroup } from "xsolla-uikit";
import PAh2 from "../PAh2";
import styled, { css } from "styled-components";

export default function PAaccountingPayouts() {
  return (
    <div>



      <FormGroup indentation="lg">
        <div style={{ display: "flex", alignItems: "center" }}>
          <PAh2 title="Payouts" indentation="xs"></PAh2>

          <CssH2Extra>
            <div className="custom-dropdown custom-dropdown--position-null">
              <div style={{ display: "block" }}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    display: "block"
                  }}
                >
                  <button
                    name="year-picker"
                    value="2019, All months"
                    className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left xsui-input--read-only"
                    type="button"
                    data-id="year-picker"
                    data-value="2019, All months"
                  >
                    2019, All months
                  </button>
                  <div className="xsui-input__icon">
                    <i
                      className="xsui-icon xsui-icon-calendar"
                      style={{ fontSize: 24, color: "inherit" }}
                    />
                  </div>
                </div>
                <div />
              </div>
              <div />
            </div>
          </CssH2Extra>
        </div>
      </FormGroup>






      <div className="payouts-summary">
        <div className="payouts-summary__title">Payouts total for</div>
        <div className="payouts-summary__items">
          <div
            // className="payouts-summary__items__item"
          >
            <div className="payouts-summary__items__item__currency">USD</div>
            <div
              className="payouts-summary__items__item__amount"
              data-id="payouts-summary_USD"
            >
              543,017.15
            </div>
          </div>
        </div>
      </div>

      <FormGroup>
        <div className="ui-table">
          <div className="ui-table__head">
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ maxWidth: "11.5%" }}
            >
              Report date
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "11.5%" }}
            >
              Amount
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "14.5%" }}
            >
              Convert to payout currency
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "14.5%" }}
            >
              Document no. &amp; Payout date
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "11.5%" }}
            >
              Recipient
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "12.5%" }}
            >
              Payment currency
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "11.5%" }}
            >
              Cancelled transactions total
            </div>
            <div
              className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
              style={{ maxWidth: "11.5%" }}
            >
              Reporting period
            </div>
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ maxWidth: "1%" }}
            />
          </div>



          <div className="ui-table__body">
            <div>
              <div
                className="ui-table__body__row ui-table__body__row--v-align-center"
                data-id="table.rows[0]"
              >


                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data payouts-table__column__data--bold"
                      data-id="date_created"
                    >
                      10/7/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div className="xsui-tooltip">
                      <div
                        className
                        data-tooltipped
                        aria-describedby="tippy-tooltip-1"
                        data-original-title="undefined"
                        style={{ display: "inline" }}
                      >
                        <div className="payouts-table__status-container">
                          <div className="xsui-status-dot xsui-status-dot--testing">
                            <div className="xsui-status-dot__icon" />
                            <div className="xsui-status-dot__entry" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="amount_in_draft_currency"
                    >
                      26,608.07
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="draft_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column payouts-table__column--subrows">
                    <div
                      className="payouts-table__column__data payouts-table__column__data__id"
                      data-id="draft_document_id"
                    />
                    <div
                      className="payouts-table__column__data"
                      data-id="date_paid"
                    />
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="legal_entity_name"
                    >
                      SNAPSHOT GAMES INC
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "12.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="payment_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="cancelled_transactions_amount"
                    >
                      326.80
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="reporting_period"
                    >
                      01.10.2019 - 07.10.2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "1%" }}
                >
                  <div className="payouts-table__download-container">
                    <div className="xsui-dropdown">
                      <button
                        className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button__icon"
                        type="button"
                      >
                        <div className="xsui-button__wrapper">
                          <div className="xsui-button__content">
                            <i
                              className="xsui-icon xsui-icon-download"
                              style={{ fontSize: 24, color: "inherit" }}
                            />
                          </div>
                        </div>
                      </button>
                      <div />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="ui-table__body__row ui-table__body__row--v-align-center"
                data-id="table.rows[1]"
              >
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data payouts-table__column__data--bold"
                      data-id="date_created"
                    >
                      9/30/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div className="xsui-tooltip">
                      <div
                        className
                        data-tooltipped
                        aria-describedby="tippy-tooltip-2"
                        data-original-title="undefined"
                        style={{ display: "inline" }}
                      >
                        <div className="payouts-table__status-container">
                          <div className="xsui-status-dot xsui-status-dot--enabled">
                            <div className="xsui-status-dot__icon" />
                            <div className="xsui-status-dot__entry" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="amount_in_draft_currency"
                    >
                      19,139.90
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="draft_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column payouts-table__column--subrows">
                    <div
                      className="payouts-table__column__data payouts-table__column__data__id"
                      data-id="draft_document_id"
                    >
                      BoA 10/07/2019
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="date_paid"
                    >
                      10/6/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="legal_entity_name"
                    >
                      SNAPSHOT GAMES INC
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "12.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="payment_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="cancelled_transactions_amount"
                    >
                      203.25
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="reporting_period"
                    >
                      23.09.2019 - 30.09.2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "1%" }}
                >
                  <div className="payouts-table__download-container">
                    <div className="xsui-dropdown">
                      <button
                        className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button__icon"
                        type="button"
                      >
                        <div className="xsui-button__wrapper">
                          <div className="xsui-button__content">
                            <i
                              className="xsui-icon xsui-icon-download"
                              style={{ fontSize: 24, color: "inherit" }}
                            />
                          </div>
                        </div>
                      </button>
                      <div />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="ui-table__body__row ui-table__body__row--v-align-center"
                data-id="table.rows[2]"
              >
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data payouts-table__column__data--bold"
                      data-id="date_created"
                    >
                      9/22/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div className="xsui-tooltip">
                      <div
                        className
                        data-tooltipped
                        aria-describedby="tippy-tooltip-3"
                        data-original-title="undefined"
                        style={{ display: "inline" }}
                      >
                        <div className="payouts-table__status-container">
                          <div className="xsui-status-dot xsui-status-dot--enabled">
                            <div className="xsui-status-dot__icon" />
                            <div className="xsui-status-dot__entry" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="amount_in_draft_currency"
                    >
                      11,238.80
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="draft_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column payouts-table__column--subrows">
                    <div
                      className="payouts-table__column__data payouts-table__column__data__id"
                      data-id="draft_document_id"
                    >
                      BoA 09/27/2019
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="date_paid"
                    >
                      9/26/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="legal_entity_name"
                    >
                      SNAPSHOT GAMES INC
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "12.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="payment_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="cancelled_transactions_amount"
                    >
                      128.63
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="reporting_period"
                    >
                      16.09.2019 - 22.09.2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "1%" }}
                >
                  <div className="payouts-table__download-container">
                    <div className="xsui-dropdown">
                      <button
                        className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button__icon"
                        type="button"
                      >
                        <div className="xsui-button__wrapper">
                          <div className="xsui-button__content">
                            <i
                              className="xsui-icon xsui-icon-download"
                              style={{ fontSize: 24, color: "inherit" }}
                            />
                          </div>
                        </div>
                      </button>
                      <div />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="ui-table__body__row ui-table__body__row--v-align-center"
                data-id="table.rows[3]"
              >
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data payouts-table__column__data--bold"
                      data-id="date_created"
                    >
                      9/15/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div className="xsui-tooltip">
                      <div
                        className
                        data-tooltipped
                        aria-describedby="tippy-tooltip-4"
                        data-original-title="undefined"
                        style={{ display: "inline" }}
                      >
                        <div className="payouts-table__status-container">
                          <div className="xsui-status-dot xsui-status-dot--enabled">
                            <div className="xsui-status-dot__icon" />
                            <div className="xsui-status-dot__entry" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="amount_in_draft_currency"
                    >
                      24,469.77
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="draft_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "14.5%" }}
                >
                  <div className="payouts-table__column payouts-table__column--subrows">
                    <div
                      className="payouts-table__column__data payouts-table__column__data__id"
                      data-id="draft_document_id"
                    >
                      BoA 09/20/2019
                    </div>
                    <div
                      className="payouts-table__column__data"
                      data-id="date_paid"
                    >
                      9/19/2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="legal_entity_name"
                    >
                      SNAPSHOT GAMES INC
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "12.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="payment_currency"
                    >
                      USD
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="cancelled_transactions_amount"
                    >
                      297.23
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "11.5%" }}
                >
                  <div className="payouts-table__column">
                    <div
                      className="payouts-table__column__data"
                      data-id="reporting_period"
                    >
                      08.09.2019 - 15.09.2019
                    </div>
                  </div>
                </div>
                <div
                  className="ui-table__column ui-table__column--indentation-sm"
                  style={{ maxWidth: "1%" }}
                >
                  <div className="payouts-table__download-container">
                    <div className="xsui-dropdown">
                      <button
                        className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button__icon"
                        type="button"
                      >
                        <div className="xsui-button__wrapper">
                          <div className="xsui-button__content">
                            <i
                              className="xsui-icon xsui-icon-download"
                              style={{ fontSize: 24, color: "inherit" }}
                            />
                          </div>
                        </div>
                      </button>
                      <div />
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </FormGroup>
    </div>
  );
}

const CssH2Extra = styled.span`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
`;
